import { render, staticRenderFns } from "./OngoingTable.vue?vue&type=template&id=59e5a612"
import script from "./OngoingTable.vue?vue&type=script&lang=js"
export * from "./OngoingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports